import * as servicesService from 'common/services/services.service';
import get from 'lodash/get';
import {
  getServicesSucceed,
  getServicesFailure,
  createServiceSucceed,
  updateServiceSucceed,
  deleteServiceSucceed
} from '../actions';

export const SERVICES_API_ERRORS = {
  NAME_EXISTS: 'name-already-existed',
  UNKNOWN: 'unknown'
};

const resolveApiError = e => {
  const status = get(e, 'response.status');
  const desc = get(e, 'response.data.message', '');
  const isNameExists = status === 400 && desc.includes('already exists');

  if (isNameExists) return SERVICES_API_ERRORS.NAME_EXISTS;

  return SERVICES_API_ERRORS.UNKNOWN;
};

export const getServices = () => async dispatch => {
  try {
    const services = await servicesService.fetchServices();
    dispatch(getServicesSucceed(services));
    return services;
  } catch ({ response = {} }) {
    dispatch(getServicesFailure(response.status));
    return [];
  }
};

export const createService = newService => async dispatch => {
  try {
    if (!servicesService.validateServicePathStrategy(newService))
      throw new Error(
        'createService failed: service has no valid pathStrategy'
      );

    const newServiceRes = await servicesService.createService(newService);
    dispatch(createServiceSucceed(newServiceRes));
    return newServiceRes;
  } catch (e) {
    return { error: resolveApiError(e) };
  }
};

export const updateService = service => async dispatch => {
  try {
    if (!servicesService.validateServicePathStrategy(service))
      throw new Error(
        'updateService failed: service has no valid pathStrategy'
      );
    const updatedService = await servicesService.updateService(service);
    dispatch(updateServiceSucceed(updatedService));
    return updatedService;
  } catch (e) {
    return { error: resolveApiError(e) };
  }
};

export const deleteService = serviceId => async dispatch => {
  try {
    const deletedServiceResponse = await servicesService.deleteService(
      serviceId
    );
    dispatch(deleteServiceSucceed(serviceId));
    return deletedServiceResponse;
  } catch (e) {
    return { error: resolveApiError(e) };
  }
};
